import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Typography, FormControlLabel, Checkbox } from "@mui/material";

import ClientModal from "../modals/ClientModal";
import Page from "./Page";
import EntityList from "./EntityList";
import useEntity from "../../hooks/useEntity";

const Clients = () => {
  const navigate = useNavigate();

  const [openClientModal, setOpenClientModal] = useState(false);
  const [includeInactive, setIncludeInactive] = useState(false);

  const { getEntityList, setEntity, entityName, entityList, entitySchema } =
    useEntity();

  useEffect(() => {
    setEntity("Client");
  }, []);

  useEffect(() => {
    if (!entityName) return;

    getData();
  }, [entityName, includeInactive]);

  const getData = async () => {
    const filter = includeInactive ? null : { isActive: true };
    await getEntityList(filter);
  };

  const handleSearch = (searchValue) => {};

  const handleToolbarItemClick = (item) => {
    switch (item) {
      case "add":
        setOpenClientModal(true);
        break;
    }
  };

  const handleCloseModal = () => {
    setOpenClientModal(false);
  };

  const handleRowClick = (column, id) => {
    if (!id) return;

    navigate(`/client`, { state: { clientId: id } });
  };

  const handleSave = async () => {
    setOpenClientModal(false);
    await getEntityList();
  };

  const sortedClients = useMemo(() => {
    if (!Array.isArray(entityList)) return [];

    return [...entityList].sort((left, right) =>
      `${left?.name || ""}`.localeCompare(`${right?.name || ""}`, undefined, {
        sensitivity: "base",
      }),
    );
  }, [entityList]);

  return (
    <>
      <Page
        pageName="clients"
        onSearch={handleSearch}
        onToolItemClick={handleToolbarItemClick}
        includeToolbar
        items={[{ name: "add", iconName: "AddCircleOutline" }]}
      >
        <Box sx={{ padding: "8px 0 12px 8px" }}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={includeInactive}
                onChange={(e) => setIncludeInactive(e.target.checked)}
              />
            }
            label={
              <Typography sx={{ fontSize: "12px" }}>
                Show Inactive Clients
              </Typography>
            }
          />
        </Box>
        <EntityList
          entityList={sortedClients}
          entitySchema={entitySchema}
          onRowClick={handleRowClick}
          columns={[{ name: "name", clickable: true }]}
        />
      </Page>

      <ClientModal
        open={openClientModal}
        onClose={handleCloseModal}
        onSave={handleSave}
      />
    </>
  );
};

export default Clients;
